export default "__VITE_ASSET__CUJ4gPbc__"